import { createHashRouter, Outlet, redirect } from 'react-router-dom';
import { ErrorBoundary } from 'src/modules/common/components/ErrorBoundary/ErrorBoundary';
import { SensorsPage } from 'src/sensors/list/SensorsPage.tsx';
import { SensorAccessoriesPage } from 'src/sensors/accessories/SensorsAccessoriesPage.tsx';
import { PrefetchSensorsCheckout } from 'src/sensors/checkout/PrefetchSensorsCheckout.tsx';
import { SharePage } from 'src/sensors/SharePage.tsx';
import { PATHS } from 'src/sensors/common/types/Paths';
import { createChildrenRoute } from 'src/projects/createChildrenRoute.tsx';
import { checkLocalState } from 'src/checkLocalState.ts';

const errorElement = <ErrorBoundary/>;

export const router = () => createHashRouter([
    {
        path: `${PATHS.Sensors}/:page`,
        element: <Outlet/>,
        children: createChildrenRoute(<SensorsPage/>),
        errorElement,
    },
    {
        path: `${PATHS.Accessories}/:sensorLabel/:page`,
        element: <Outlet/>,
        children: createChildrenRoute(<SensorAccessoriesPage/>),
        errorElement,
        loader: () => checkLocalState(`${PATHS.Sensors}/1`),
    },
    {
        path: `${PATHS.Checkout}/:sensorLabel/:page`,
        element: <Outlet/>,
        children: createChildrenRoute(<PrefetchSensorsCheckout/>),
        errorElement,
        loader: () => checkLocalState(`${PATHS.Sensors}/1`),
    },
    {
        path: PATHS.Share,
        element: <SharePage/>,
        errorElement,
    },
    {
        path: '*',
        loader: () => redirect(`${PATHS.Sensors}/1`),
        errorElement,
    },
]);
